import React from 'react';
import * as PropTypes from 'prop-types';
import styled from 'styled-components';

const StepContentStyle = styled.div`
	background-color: ${({theme}) => theme.background.primary};
	border-top: ${({theme}) => `1px solid ${theme.border.primary}`};
	border-bottom: ${({theme}) => `1px solid ${theme.border.primary}`};
	height: 30px;
	min-width: fit-content;
	width: ${({width}) => width}px;
	display: flex;
	align-items: center;
	justify-content: center;

	text-transform: uppercase;
	font-size: 10px;
	color: ${({theme}) => theme.typographyLight.primary};
	letter-spacing: 0.5px;
	font-weight: 500;
`;

export const StepContent = ({content, width, userpilot, cy}) => {
	return (
		<StepContentStyle width={width} data-userpilot={userpilot} data-cy={cy}>
			{content}
		</StepContentStyle>
	);
};

StepContent.propTypes = {
	content: PropTypes.node.isRequired,
	width: PropTypes.number.isRequired,
	/**
	 * ID needed for on-boarding tool
	 */
	userpilot: PropTypes.string,
	/**
	 * ID needed for Cypress testing
	 */
	cy: PropTypes.string,
};
